import React from "react";
import { Provider } from "react-redux";
import { Button } from "antd";
import { LoginOutlined } from '@ant-design/icons';
import { logout } from './utils/authActions';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { InteractionRequiredAuthError } from "@azure/msal-browser";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";

// Css
import "antd/dist/reset.css";

// Local imports
import { MainLayout } from "./components/Layout/MainLayout.component";
import { Home, Users, NotFound, Applications, Vendors, Publishers, Devices } from "./pages";
import { store } from "./api/store";
import { loginRequest } from "./utils/authConfig";
import { Login } from "./pages/Login.page";
import { UserDetails } from "./pages/UserDetails.page";
import { AppDetails } from "./pages/AppDetails.page";
import { VendorsDetails } from "./pages/VendorDetails.page";
import { PublishersDetails } from "./pages/PublishersDetails.page";
import { DevicesDetails } from "./pages/DevicesDetails.page";
import { setToken } from "./api/authToken";




const MainContent = () => {
  const { instance,  accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [userName, setUserName] = useState("");
  useEffect(() => {
    if (accounts.length > 0) {
      const request = {
        scopes: ["User.Read"],
        account: accounts[0],
      };

      instance.acquireTokenSilent(request).then((response) => {
        fetch("https://graph.microsoft.com/v1.0/me", {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        })
          .then((res) => res.json())
          .then((data) => {
            setUserName(data.displayName);
          })
          .catch((error) => {
            console.error("Error fetching user data:", error);
          });
      }).catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          instance.acquireTokenRedirect(request);
        }
      });
    }
  }, [instance, accounts]);


  React.useEffect(() => {
    if (activeAccount) {
      setToken(activeAccount.idToken);
    }
  }, [activeAccount]);

  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: "create",
      })
      .catch((error) => console.error("Login Redirect Error:", error));
  };


  
  return (
    <div className="App">
      <AuthenticatedTemplate>
        {activeAccount ? (
          <Provider store={store}>
            <BrowserRouter>
              <MainLayout>
              <Routes>
  <Route path="/" element={<Navigate to="/home" replace />} />
  <Route path="/login" element={<Login />} />
  <Route path="/home" element={<Home userName={userName} />} />
  <Route path="/users" element={<Users />} />
  <Route path="/user/:userId" element={<UserDetails />} />
  <Route path="/applications" element={<Applications />} />
  <Route path="/applications/:AppId" element={<AppDetails />} />
  <Route path="/publishers" element={<Publishers />} />
  <Route path="/publishers/:PublishersId" element={<PublishersDetails />} />
  <Route path="/vendors" element={<Vendors />} />
  <Route path="/vendors/:VendorId" element={<VendorsDetails />} />
  <Route path="/devices" element={<Devices />} />
  <Route path="/devices/:DevicesId" element={<DevicesDetails />} />
  <Route path="/*" element={<NotFound />} />

</Routes>
              </MainLayout>
            </BrowserRouter>
          </Provider>
        ) : null}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className="login-container">
          <div className="login-box">
            <h1 className="portalTitle">Welcome to SAM</h1>
            <Button
              icon={<LoginOutlined />}
              className="signInButton"
              onClick={handleRedirect}
            >
              Login 
            </Button>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
};

function App({ instance }) {
  return (
    <MsalProvider instance={instance}>
      <MainContent />
    </MsalProvider>
  );
}

export default App;
